<app-selector label="File" [isEmptySelectable]="isEmptySelectable" [data]="filesCoreService.filesList$ | async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="filesCoreService.loading" [hint]="hint">
</app-selector>
